import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
var Wrapper = styled.div.withConfig({
  displayName: "Flyout__Wrapper",
  componentId: "sc-1l6var5-0"
})(["\n  position: relative;\n  display: inline-block;\n"]);
var bottomStyles = css(["\n  top: calc(100% + 0.5rem);\n  left: 50%;\n  transform: translateX(-50%);\n"]);
var topStyles = css(["\n  bottom: calc(100% + 0.5rem);\n  left: 50%;\n  transform: translateX(-50%);\n"]);
var leftStyles = css(["\n  top: 50%;\n  right: calc(100% + 0.5rem);\n  transform: translateY(-50%);\n"]);
var rightStyles = css(["\n  top: 50%;\n  left: calc(100% + 0.5rem);\n  transform: translateY(-50%);\n"]);
var Popup = styled.div.withConfig({
  displayName: "Flyout__Popup",
  componentId: "sc-1l6var5-1"
})(["\n  z-index: ", ";\n\n  position: absolute;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  display: block;\n\n  &:focus {\n    outline: 2px solid ", ";\n  }\n\n  ", ";\n"], function (props) {
  return props.theme.zIndex && props.theme.zIndex.flyout ? props.theme.zIndex.flyout : 100;
}, function (props) {
  return props.direction === 'bottom' && bottomStyles;
}, function (props) {
  return props.direction === 'top' && topStyles;
}, function (props) {
  return props.direction === 'right' && rightStyles;
}, function (props) {
  return props.direction === 'left' && leftStyles;
}, function (props) {
  return props.theme.focusColor || '#7c89d3';
}, function (props) {
  return props.theme.flyout ? props.theme.flyout.popupStyle : null;
});
/**
 * ### Theme Properties
 *
 * - `zindex.flyout`: Global collection of z-indices. Defaults to `100`.
 * - `flyout.popupStyle`: Styled Components mixin styles to add to the popup.
 *
 */

var Flyout =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Flyout, _Component);

  function Flyout(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.setState({
        open: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (ev) {
      ev.stopPropagation();

      if (!_this.state.open) {
        _this.setState({
          open: true
        }, function () {
          _this.children.focus();
        });
      } else {
        _this.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      _this.blurTimeout = setTimeout(function () {
        if (!_this.flyout.contains(document.activeElement) || _this.flyout === document.activeElement) {
          // Focus has left the flyout container
          _this.close();
        }
      });
    });

    _this.state = {
      open: false
    };
    return _this;
  }

  var _proto = Flyout.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.blurTimeout) {
      clearTimeout(this.blurTimeout);
    }
  };

  _proto.renderChildren = function renderChildren(children, closeButton) {
    var _this2 = this;

    if (closeButton === void 0) {
      closeButton = null;
    }

    var direction = this.props.direction;

    if (typeof children === 'function') {
      var childrenProps = {
        close: this.close
      };
      children = children(childrenProps);
    }

    return React.createElement(Popup, {
      ref: function ref(el) {
        return _this2.children = el;
      },
      tabIndex: "-1",
      direction: direction
    }, closeButton, children);
  };

  _proto.renderToggle = function renderToggle(toggleButton) {
    return React.cloneElement(toggleButton, {
      onClick: this.onClick,
      'aria-expanded': this.state.open
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        children = _this$props.children,
        direction = _this$props.direction,
        toggleButton = _this$props.toggleButton,
        closeButton = _this$props.closeButton,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "direction", "toggleButton", "closeButton"]);

    var open = this.state.open;

    if (closeButton) {
      closeButton = React.cloneElement(closeButton, {
        onClick: this.onClick
      });
    }

    return React.createElement(Wrapper, _extends({
      ref: function ref(el) {
        return _this3.flyout = el;
      },
      onBlur: this.handleBlur
    }, props), this.renderToggle(toggleButton), open && this.renderChildren(children, closeButton));
  };

  return Flyout;
}(Component);

_defineProperty(Flyout, "propTypes", {
  /**
   * A React element to render that will open or close the flyout. An `onClick` prop will automatically be added that toggles the `open` state.
   */
  toggleButton: PropTypes.element.isRequired,

  /**
   * The content of the open flyout. It will be completely unstyled. If given
   * a function, it will be passed an object with a `close` method for closing
   * the flyout.
   */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * A button to render inside the popup that will close the flyout.
   */
  closeButton: PropTypes.element,

  /**
   * Which direction to open relative to the toggle
   */
  direction: PropTypes.oneOf(['bottom', 'top', 'right', 'left'])
});

_defineProperty(Flyout, "defaultProps", {
  direction: 'bottom'
});

_defineProperty(Flyout, "Popup", Popup);

export { Flyout as default };